// ── Editable brand settings ─────────────────────────────────────────────
// Paste your YouTube video ID (the part after watch?v=) to make the VSL play.
export const YOUTUBE_VIDEO_ID = "";

// Paste your Calendly link. Qualified leads are sent here after the form.
export const CALENDLY_URL = "";

// Lead qualification form, shown after clicking "Book a Personal Call".
// type: text | email | tel | textarea | radio | checkbox
// grid: 2 renders options in a two-column layout; desc shows a sub-line under a radio label.
export const FORM_SECTIONS = [
  {
    title: "1. Contact Details",
    fields: [
      { name: "name", label: "Full Name", type: "text", placeholder: "John Doe", required: true },
      { name: "email", label: "Email Address", type: "email", placeholder: "john@company.com", required: true },
      { name: "phone", label: "Phone / WhatsApp", type: "tel", placeholder: "+91 98765 43210", required: true },
      { name: "business_type", label: "Business Type", type: "text", placeholder: "e.g. Marketing Agency", required: false },
    ],
  },
  {
    title: "2. Business Profile",
    fields: [
      {
        name: "business_age",
        label: "How long have you been running this business?",
        type: "radio",
        grid: 2,
        required: false,
        options: ["Less than 1 year", "1 - 2 Years", "3 - 5 Years", "5+ Years"],
      },
      {
        name: "revenue",
        label: "Current Average Monthly Revenue?",
        type: "radio",
        grid: 2,
        required: true,
        options: [
          "< ₹1 Lakh / Month",
          "₹1 Lakh - ₹5 Lakhs / Month",
          "₹5 Lakhs - ₹10 Lakhs / Month",
          "₹10 Lakhs - ₹25 Lakhs / Month",
          "₹25 Lakhs+ / Month",
        ],
      },
      {
        name: "revenue_situation",
        label: "Which best describes your revenue situation?",
        type: "radio",
        grid: 1,
        required: false,
        options: [
          "Feast or Famine (Unpredictable)",
          "Stable but Stuck (Hit a ceiling)",
          "Growing but Chaotic (Operations breaking)",
          "Declining (Losing clients)",
        ],
      },
    ],
  },
  {
    title: "3. The Problem",
    fields: [
      { name: "problem_impact", label: "How is this situation affecting you right now?", type: "textarea", placeholder: "Stress, working weekends, burnout…", required: false },
      { name: "worry", label: "If nothing changes in 3-6 months, what are you most worried about?", type: "textarea", placeholder: "Going back to a job, losing staff…", required: false },
      {
        name: "tried",
        label: "What have you already tried to fix this?",
        type: "checkbox",
        grid: 2,
        required: false,
        options: [
          "Paid Ads (FB/Insta/Google)",
          "Cold Outreach / DMs",
          "Posting Content",
          "Hiring Agencies",
          "Buying Courses",
          "Nothing yet",
        ],
      },
    ],
  },
  {
    title: "4. Commitment",
    fields: [
      {
        name: "seriousness",
        label: "How serious are you about fixing this problem now?",
        type: "radio",
        grid: 1,
        required: true,
        options: [
          { label: "10 - Extremely Serious", desc: "I need to fix this immediately." },
          { label: "5 - Somewhat Serious", desc: "It's annoying but I can live with it.." },
          { label: "1 - Just Curious", desc: "I'm just browsing." },
        ],
      },
      {
        name: "invest_readiness",
        label: "If this call shows a clear path, are you in a position to invest?",
        type: "radio",
        grid: 1,
        required: true,
        options: [
          "Yes, I have capital ready to deploy.",
          "I have access to capital (credit/partners).",
          "No, I do not have any funds to invest.",
        ],
      },
      { name: "why_now", label: "Why do you want to solve this NOW instead of waiting?", type: "textarea", placeholder: "", required: false },
      { name: "hear_about", label: "How did you hear about us?", type: "text", placeholder: "LinkedIn, Instagram, Referral…", required: false },
      {
        name: "best_time",
        label: "Best time to reach you?",
        type: "radio",
        grid: 2,
        required: true,
        options: [
          "9:00 AM - 12:00 PM",
          "12:00 PM - 3:00 PM",
          "3:00 PM - 6:00 PM",
          "6:00 PM - 9:00 PM",
        ],
      },
    ],
  },
];
